
import { useState, useEffect } from 'react';

export default function WhatsAppButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [pulse, setPulse] = useState(true);

  // Show button after a short delay
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  // Toggle pulse animation
  useEffect(() => {
    const interval = setInterval(() => {
      setPulse((prev) => !prev);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          showTooltip
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-2 pointer-events-none'
        }`}
      >
        <div className="bg-navy-800 rounded-xl shadow-xl px-4 py-3 max-w-[220px] relative border border-navy-700">
          <p className="text-sm font-semibold text-white leading-snug">
            Besoin d&apos;aide ? 💬
          </p>
          <p className="text-xs text-ocean-300 mt-1">
            Contactez-nous sur WhatsApp
          </p>
          <div className="absolute -bottom-2 right-6 w-4 h-4 bg-navy-800 border-r border-b border-navy-700 transform rotate-45" />
        </div>
      </div>

      {/* Button */}
      <a
        href="https://wa.me/33765730333?text=Bonjour%20!%20Je%20souhaite%20avoir%20des%20informations%20sur%20vos%20locations."
        target="_blank"
        rel="nofollow noopener noreferrer"
        aria-label="Contactez-nous sur WhatsApp"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="relative group cursor-pointer"
      >
        {/* Pulse animation */}
        <span
          className={`absolute inset-0 rounded-full bg-[#25D366] transition-opacity duration-1000 ${
            pulse ? 'opacity-40 animate-ping' : 'opacity-0'
          }`}
        />
        {/* Main button */}
        <div className="relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300">
          <i className="ri-whatsapp-fill text-white text-2xl" />
        </div>
      </a>
    </div>
  );
}
